import { useTranslation } from 'react-i18next';
import { ProgramSource } from '../../../../queries/ats/titles/types/sources';
import { localizedRelativeTime } from '../../../../utils/ats-details-utils';
import { CallToAction } from '../call-to-action-button';

export function ExpiredCallToAction({ source }: { source: ProgramSource }) {
  const { t } = useTranslation();

  return (
    <CallToAction
      text={{
        primary: t('details:unavailable'),
        secondary: localizedRelativeTime(source.startTime, 'airtime'),
      }}
      image={{
        src: source.image,
        alt: source.name,
      }}
      onClick={() => void 0}
      icon={null}
      disabled
    />
  );
}
